export default __webpack_public_path__ + "static/media/port3.7f41458f.jpg";